import React, { useState, useEffect, useCallback, act } from 'react'
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn'
import { useMsal } from '@azure/msal-react'
import { useHistory, useLocation } from 'react-router-dom'
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'
import Button from '../../component/Common/Button'
import Dropdown from "../../component/Common/Dropdown";
import InputText from '../../component/Common/InputText'
import FormInput from '../../component/Common/FormInput'
import _, { set } from 'lodash'
import './contract-report-home.css'
import PageSubTitle from '../../component/Common/PageSubTitle'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import moment from 'moment-timezone';
import Modal from 'react-modal';
import * as XLSX from 'xlsx'
import { FaExternalLinkAlt, FaDownload } from 'react-icons/fa';
import { getTextFromShortCode } from '../../utils/textMappings';
import { useLooksUpData } from '../../utils/getLookupTableData';
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import { SubmissionStatus, ReviewStatus, ChooseActionsType, ActivityLkpcd, Success_Messages, Warning_Messages, Error_Messages } from '../../utils/statusConstantValues';
import { downloadFileToken } from "../../utils/url-constant";
import { toast } from 'react-toastify';
import { useAccessControl } from '../../utils/AccessControlContext';
import Cookies from 'js-cookie';
import { formatDateForDisplay, setDateInCST } from '../../utils/dateUtils';

export default function ActionDetails() {
    const { instance, accounts } = useMsal()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const [isFilesGridLoading, setIsFilesGridLoading] = useState(false)
    const location = useLocation();
    const [reportTypeList, setReportTypeList] = useState<any>([])
    const [frequencyLKPCDList, setFrequencyLKPCDList] = useState<any>([])
    const [businessStatusLKPCDList, setBusinessStatusLKPCDList] = useState<any>([])
    const [reportActivityList, setReportActivityList] = useState<any>([])
    const [mcReportList, setMcReportList] = useState<any>([])
    const [afStatusLKPCDList, setAfStatusLKPCDList] = useState<any>([])
    const [reportActivityLKPCDList, setReportActivityLKPCDList] = useState<any>([])
    const [submissionModeList, setSubmissionModeList] = useState<any>([])
    const [uploadedFileSubmissionModeList, setUploadedFileSubmissionModeList] = useState<any>([])
    const [uploadedFileTypeKPCDList, setUploadedFileTypeKPCDList] = useState<any>([])
    const [uploadedErrorFileTypeKPCDList, setUploadedErrorFileTypeKPCDList] = useState<any>([])
    const userType = sessionStorage.getItem('signedInUserType');
    const ReportInventoryService = useReportInventoryService();
    const [uploadedFileList, setUploadedFileList] = useState<any>([])
    const { getMasterTableLookupValueData, getMasterTableLookupData, getOrganizationUnitsTableLookupData } = useLooksUpData();
    const [combinedNotes, setCombinedNotes] = useState('');
    const { checkAccess } = useAccessControl();
    let [mcOrgUnitsList, setMcOrgUnitsGroupsList] = useState<any>([]);
    const [recordData, setRecordData] = useState((location?.state as LocationState)?.recordData || null);
    const [activityData, setActivityData] = useState((location?.state as LocationState)?.activityData || null);
    const [isCertified, setIsCertified] = useState(false);
    const [reviewDecisionLKPCDList, setReviewDecisionLKPCDList] = useState<any>([])
    const [mcoActionDecisionLKPCDList, setMcoActionDecisionLKPCDList] = useState<any>([])
    const [reportSubActivityList, setReportSubActivityList] = useState<any>([])

    const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
    const isNonStateUser = loggedInUserDetails.organizationUnitCode !== "NEDHHS";
    const [certName, setCertName] = useState('');
    const [certTitle, setCertTitle] = useState('');
    const [certificationData, setCertificationData] = useState<any>({});
    let envPrefix = process.env.REACT_APP_ENV_PREFIX || '';

    useEffect(() => {
        setIsLoading(true);
        const timeoutId = setTimeout(() => {
            if (userType === null && (!accounts?.[0]?.localAccountId)) {
                history.push('/sign-in');
            }
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [accounts, history, userType]);

    const fetchGetMasterTableLookupValueData = async () => {
        try {
            const response = await getMasterTableLookupValueData();
            if (response) {
                const { data } = response;

                const filterAndMapData = (groups: string | string[], table: string, column: string) => {
                    return data
                        .filter((dt: any) => groups.includes(dt.lkpcd_group) && dt.table_name === table && dt.column_name === column)
                        .map((code: any) => ({
                            lkpdmn_lkpcd: `${code.lkpdmn_lkpcd}`,
                            lkdmn_lkpcd_desc: code.lkdmn_lkpcd_desc,
                            lkpcd_group: code.lkpcd_group,
                        }));
                };

                const mcBusinessStatusLKPCD = filterAndMapData('NG', 'MCT_REPORT_INSTANCE', 'LAST_SUBMSN_STATUS_LKPCD');
                const mcFrequencyLKPCD = filterAndMapData('NG', 'MC_PROGRAM_REPORT', 'DUE_DATE_FREQUENCY_LKPCD');
                const mcAfStatusLKPCD = filterAndMapData('NG', 'MCT_REPORT_INSTANCE', 'LAST_REVIEW_STATUS_LKPCD');
                const mcSubmisstionMode = filterAndMapData('AD', 'MC_PROGRAM_REPORT', 'REPORT_SBMSN_MODE_LKPCD');
                const mcReportType = filterAndMapData('AL', 'MC_PROGRAM_REPORT', 'REPORTING_TYPE_LKPCD');
                const mcReportActivityList = filterAndMapData('NG', 'MCT_REPORT_ACTIVITY', 'ACTIVITY_LKPCD');
                const mcUploadedFileSubmisstionMode = filterAndMapData('NG', 'MCT_REPORT_ATTACHMENT', 'SUBMISSION_MODE_LKPCD');
                const mcUploadedFileTypeList = filterAndMapData(['RS', 'OR', 'SR', 'AI', 'ER', 'CS', 'VL','AH', 'OD'], 'MCT_REPORT_ATTACHMENT', 'UPLOAD_TYPE_LKPCD');
                const mcoChooseAnActionLKPCD = filterAndMapData('MC', 'MCT_REPORT_ACTIVITY', 'DECISION_ACTION_LKPCD');

                //for error file type
                const mcUploadedErrorFileTypeList = filterAndMapData('VL', 'MCT_REPORT_ATTACHMENT', 'UPLOAD_TYPE_LKPCD');

                const mcChooseAnActionLKPCD = () => {
                    return data
                        .filter((dt: any) => dt.table_name === "MCT_REPORT_SUBACTIVITY" && dt.column_name === 'DECISION_ACTION_LKPCD')
                        .map((code: any) => ({
                            lkpdmn_lkpcd: `${code.lkpdmn_lkpcd}`,
                            lkdmn_lkpcd_desc: code.lkdmn_lkpcd_desc,
                            lkpcd_group: code.lkpcd_group,
                        }));
                };

                setFrequencyLKPCDList(mcFrequencyLKPCD);
                setBusinessStatusLKPCDList(mcBusinessStatusLKPCD);
                setAfStatusLKPCDList(mcAfStatusLKPCD);
                setSubmissionModeList(mcSubmisstionMode);
                setReportTypeList(mcReportType);
                setReportActivityLKPCDList(mcReportActivityList);
                setUploadedFileTypeKPCDList(mcUploadedFileTypeList)
                setUploadedErrorFileTypeKPCDList(mcUploadedErrorFileTypeList)
                setUploadedFileSubmissionModeList(mcUploadedFileSubmisstionMode);
                setMcoActionDecisionLKPCDList(mcoChooseAnActionLKPCD);
                setReviewDecisionLKPCDList(mcChooseAnActionLKPCD);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchGetMcReportData = async () => {
        try {
            const response = await ReportInventoryService.getAllMcReports();
            if (response) {
                const { data } = response;
                const filterAndMapData = () => {
                    return data
                        .map((code: any) => ({
                            reportName: `${code.reportName}`,
                            reportDescription: code.reportDescription,
                        }));
                };
                setMcReportList(filterAndMapData);
            }
        } catch (e) {
            console.error(e);
        }
    }

    const fetchUploadedFilesList = async (id: any) => {
        try {
            setIsLoading(true);
            setIsFilesGridLoading(true);

            const activityResponse = await ReportInventoryService.getReportActivityList(id);
            const attachmentsResponse = await ReportInventoryService.mctReportAttachments(id);
            const blobFilesResponse = await ReportInventoryService.getUploadedFilesListBySid('mcofiles', 'NEMCIS-' + id);

            const sortedData = activityResponse.data.sort((a: any, b: any) => {
                const dateA = moment.tz(a.updatedDate, 'America/Chicago');
                const dateB = moment.tz(b.updatedDate, 'America/Chicago');
                return dateB.diff(dateA);
            });

            setReportActivityList(sortedData);

            if (attachmentsResponse && blobFilesResponse) {
                const attachments = attachmentsResponse.data;
                const blobFiles = blobFilesResponse.data;

                // Only include attachments matching the current activity
                const filteredAttachments = attachments.filter((attachment: any) => {
                    // Only keep attachments for the current activity
                    if (
                        !activityData?.mctReportActivitySid ||
                        attachment.mctActivityInstanceSid !== activityData.mctReportActivitySid
                    ) {
                        return false;
                    }

                    const isMcoSubmitterOrNonNddUser = sessionStorage.getItem('selectedProfileLabel') === 'MCO SUBMITTERS' || isNonStateUser;

                    // Exclude files with mcoViewableFlag == 'N' for MCO-Submitter and non-NDD users
                    if (isMcoSubmitterOrNonNddUser && attachment.mcoViewableFlag === 'N') {
                        return false;
                    }

                    // Find the corresponding activity for the attachment
                    const activity = activityResponse.data.find((act: any) => act.mctReportActivitySid === attachment.mctActivityInstanceSid);

                    // Exclude files where activity.submitFlag !== 'N'
                    // if (activity && activity.submitFlag === 'N') {
                    //     return false;
                    // }

                    return true;
                });

                // Combine the responses based on the id property
                const combinedResponse = filteredAttachments.map((attachment: any) => {
                    const matchingBlobFile = blobFiles.find((blobFile: any) => parseInt(blobFile.attachmentRecordId) === attachment.mctReportAttachmentSid);
                    return {
                        ...attachment,
                        ...matchingBlobFile
                    };
                });

                const sortedData = combinedResponse.sort((a: any, b: any) => {
                    const dateA = moment.tz(a.updatedDate, 'America/Chicago');
                    const dateB = moment.tz(b.updatedDate, 'America/Chicago');
                    return dateB.diff(dateA);
                });

                setUploadedFileList(sortedData);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
            setIsFilesGridLoading(false);
        }
    };
    const mapApiResponseToLocalState = (apiData: any) => {
        return {
            mct_report_instance_sid: apiData.mctReportInstanceSid,
            plan_id: apiData.planId,
            program_report_sid: apiData.programReportSid,
            period_begin_date: apiData.periodBeginDate,
            period_end_date: apiData.periodEndDate,
            latest_due_date: apiData.latestDueDate,
            current_due_date: apiData.requestedDueDate,
            original_due_date: apiData.originalDueDate,
            accepeted_due_date: apiData.acceptedDueDate,
            requested_due_date: apiData.requestedDueDate,
            current_submission_number: apiData.currentSubmissionNumber,
            last_submission_status: apiData.lastSubmsnStatusLkpcd,
            last_submission_date: apiData.lastSubmsnDate,
            last_validation_status: apiData.lastValidationStatusLkpcd,
            last_review_status: apiData.lastReviewStatusLkpcd,
            notes_summary: apiData.notesSummary,
            oprtnl_flag: apiData.oprtnlFlag,
            created_by: apiData.createdBy,
            created_date: apiData.createdDate,
            updated_by: apiData.updatedBy,
            updated_date: apiData.updatedDate,
            plan_name: (location.state as LocationState)?.recordData?.plan_name || apiData.planId,
            report_name: apiData.reportName,
            start_reference_number: apiData.stateReferenceNumber,
            uploadFiles: apiData.uploadFiles,
            reporting_type_lkpcd: apiData.reportingTypeLkpcd,
            report_sbmsn_mode_lkpcd: apiData.reportSbmsnModeLkpcd,
            due_date_frequency_lkpcd: apiData.due_date_frequency_lkpcd,
            actual_sbmsnmode_Lkpcd: apiData.actualSbmsnModeLkpcd,
            review_group_list: apiData.reviewGroupList
        };
    };

    const getMctreportinstanceDetailsById = async (id: any) => {
        try {
            const response = await ReportInventoryService.getMctreportinstanceDetailsById(id);

            if (response) {
                const { data } = response;

                let mergedData = { ...data };

                if (data?.programReportSid) {
                    const mcProgramResponse = await ReportInventoryService.getProgramReportByProgramReportSid(data?.programReportSid);
                    if (mcProgramResponse) {
                        mergedData = {
                            ...mergedData,
                            ...mcProgramResponse,
                            due_date_frequency_lkpcd: mcProgramResponse?.data?.dueDateFrequencyLkpcd,
                        };

                        const mappedData = mapApiResponseToLocalState(mergedData);
                        setRecordData(mappedData);
                    }
                } else {
                    const mappedData = mapApiResponseToLocalState(data);
                    setRecordData(mappedData);
                }

            }
        } catch (e) {
            console.error(e);
        }
    };

    const fetchOrganizationUnitsTableLookupData = async () => {
        try {
            const response = await getOrganizationUnitsTableLookupData();
            if (response) {
                const { data } = response;

                const filterAndMapData = () => {
                    return data
                        // .filter((dt: any) => dt.userGroupCode === group)
                        .map((code: any) => ({
                            organizationUnitCode: `${code.organizationUnitCode}`,
                            organizationUnitName: code.organizationUnitName,
                            organizationUnitCtgryLkpcd: code.organizationUnitCtgryLkpcd,
                            oprtnlFlag: code.oprtnlFlag,
                            parentOrgUnitCode: code.parentOrgUnitCode
                        }));
                };

                setMcOrgUnitsGroupsList(filterAndMapData);

            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            setIsLoading(true);
            const fetchPromises = [
                fetchGetMasterTableLookupValueData(),
                fetchGetMcReportData(),
                fetchOrganizationUnitsTableLookupData()
            ];

            if (recordData?.mct_report_instance_sid) {
                // fetchPromises.push(getReportActivityList(recordData.mct_report_instance_sid));
                fetchPromises.push(fetchUploadedFilesList(recordData.mct_report_instance_sid));
                fetchPromises.push(getMctreportinstanceDetailsById(recordData.mct_report_instance_sid));
            }

            await Promise.all(fetchPromises);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const isMcoUser = sessionStorage.getItem('selectedProfileLabel') === 'MCO SUBMITTERS' || isNonStateUser;
    const isMltcReviewer = sessionStorage.getItem('selectedProfileLabel') === 'NE MLTC Reviewers';

    useEffect(() => {
        const fetchOrganizationUnitsTableLookupData = async () => {
            try {
                if (activityData?.mctReportActivitySid && (activityData?.activityLkpcd === '140' || activityData?.activityLkpcd === '150')) {
                    const response = await ReportInventoryService.getActivityCertification(activityData?.mctReportActivitySid);
                    if (response) {
                        const { data } = response;
                        setCertificationData(data);
                    }
                }
            } catch (error) {
                console.error('Error fetching activity certification:', error);
            }
        }

        fetchOrganizationUnitsTableLookupData();

    }, [activityData?.activityLkpcd]);

    useEffect(() => {
        let notesArr: string[] = [];

        // Hide all notes for MCO-side users when activity is initial review (lkpcd === 180)
        if (activityData?.activityLkpcd === '180' && isMcoUser) {
            setCombinedNotes('');
            return;
        }

        // Main activity notes - only show for activities other than 190, 260, 280, 308, 320, 350
        const hiddenMainNotesActivityCodes = ['190', '260', '280', '308', '320', '350'];
        if (
            !hiddenMainNotesActivityCodes.includes(activityData?.activityLkpcd) &&
            activityData?.activityNotes &&
            activityData.activityNotes.trim() !== ''
        ) {
            const formattedDate = formatDateAndTime(activityData.updatedDate);
            const updatedByValue = isNonStateUser
                ? maskUpdatedBy(activityData.updatedBy)
                : activityData.updatedBy;
            notesArr.push(
                `<p>${formattedDate} ${updatedByValue} - ${activityData.activityNotes.replace(/<\/?p>/g, '')}</p>`
            );
        }

        // Sub-activity notes
        if (Array.isArray(reportSubActivityList) && reportSubActivityList.length > 0) {
            reportSubActivityList.forEach((sub: any) => {
                if (activityData?.activityLkpcd === '180'  && isMcoUser) {
                    setCombinedNotes('');
                    return;
                }

                if (
                    sub.subActivityNotes &&
                    sub.subActivityNotes.trim() !== ''
                ) {
                    const formattedDate = formatDateAndTime(sub.updatedDate);
                    const updatedByValue = isNonStateUser
                        ? maskUpdatedBy(sub.updatedBy)
                        : sub.updatedBy;
                    notesArr.push(
                        `<p>${formattedDate} ${updatedByValue} - ${sub.subActivityNotes.replace(/<\/?p>/g, '')}</p>`
                    );
                }
            });
        }

        setCombinedNotes(notesArr.join(''));
    }, [activityData?.mctReportActivitySid, activityData?.activityLkpcd, reportSubActivityList, isNonStateUser, isMltcReviewer, isMcoUser]);

    interface ContractReport {
        mct_report_instance_sid: string;
        plan_id: string;
        program_report_sid: string;
        period_begin_date: string;
        period_end_date: string;
        latest_due_date: string;
        accepeted_due_date: string;
        requested_due_date: string;
        current_due_date: string;
        original_due_date: string;
        current_submission_number: string;
        last_submission_status: string;
        last_submission_date: string;
        last_validation_status: string;
        last_review_status: string;
        notes_summary: string;
        oprtnl_flag: string;
        created_by: string;
        created_date: string;
        updated_by: string;
        updated_date: string;
        plan_name: string;
        report_name: string;
        start_reference_number: string;
        uploadFiles: string;
        reporting_type_lkpcd: string;
        report_sbmsn_mode_lkpcd: string;
        due_date_frequency_lkpcd: string;
        actual_sbmsnmode_Lkpcd: string;
        review_group_list: string
    };

    interface LocationState {
        recordData?: ContractReport;
        activityData?: any;
    }

    function handleCancel() {
        history.goBack()
    }

    const getMatchingDescription = (list: any[], data: any) => {
        const matchedItem = list.find((code: any) => code.lkpdmn_lkpcd === data);
        return matchedItem?.lkdmn_lkpcd_desc || data;
    };

    const [viewableText, setViewableText] = useState<any[]>([
        { value: 'Y', description: 'Yes' },
        { value: 'N', description: 'No' },
    ]);

    const matchingFrequencyLkpcd = (data: any) => getMatchingDescription(frequencyLKPCDList, data);
    const matchingBusinessStatusLkpcd = (data: any) => getMatchingDescription(businessStatusLKPCDList, data);
    const matchingAfStatusLkpcd = (data: any) => getMatchingDescription(afStatusLKPCDList, data);
    const matchingSubmissionModelLkpcd = (data: any) => getMatchingDescription(submissionModeList, data);
    const matchingReportingTypeLkpcd = (data: any) => getMatchingDescription(reportTypeList, data);
    const matchingreportActivityLKPCD = (data: any) => getMatchingDescription(reportActivityLKPCDList, data);
    const matchingUploadedFileTypeLKPCD = (data: any) => getMatchingDescription(uploadedFileTypeKPCDList, data);
    const matchingUploadedErrorFileTypeLKPCD = (data: any) => getMatchingDescription(uploadedErrorFileTypeKPCDList, data);
    const matchingUploadedFileSubmissionModelLkpcd = (data: any) => getMatchingDescription(uploadedFileSubmissionModeList, data);
    const matchingMcoActionDecisionLKPCD = (data: any) => getMatchingDescription(mcoActionDecisionLKPCDList, data);

    const getMatchingMcOrgUnit = (data: any) => {
        const matchedItem = mcOrgUnitsList.find((code: any) => code.organizationUnitCode === data);
        return matchedItem?.organizationUnitName || data;
    };

    interface ContractReviewHistory {
        dateAndTime: string;
        activity: string;
        submission: string;
        updatedBy: string;
    };

    const gridStyle = { minHeight: 340, width: '100%', border: '1px solid #dfe1e5' };

     const getDownloadFileName = (fileName: string, updatedDate: string, currentSubmissionNumber?: string) => {
            const lastDotIndex = fileName.lastIndexOf('.');
            const formatDate = (dateStr: string) => {
                if (!dateStr) return '';
                // Convert date to YYYYMMDD format
                const date = moment(dateStr);
                return date.isValid() ? date.format('YYYYMMDD') : '';
            };
            const formattedDate = formatDate(updatedDate);
            const submissionPart = currentSubmissionNumber ? `_${currentSubmissionNumber}` : '';
            if (lastDotIndex === -1) {
                return `${fileName}_${formattedDate}${submissionPart}`;
            }
            const name = fileName.substring(0, lastDotIndex);
            const ext = fileName.substring(lastDotIndex); // includes the dot
            return `${name}_${formattedDate}${submissionPart}${ext}`;
        };
    
    const handleDownload = async (recordData: any, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        try {
            console.log('Starting file download...');
            const response = await ReportInventoryService.downloadFileContentAttchanchmentId('mcofiles', 'NEMCIS-' + recordData?.mctReportInstanceSid, recordData?.attachmentRecordId);
            if (response.status !== 200) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = downloadUrl;
            a.download = recordData?.fileName || 'error-details.json';
            a.download = getDownloadFileName(recordData?.fileName, recordData?.updatedDate, getSubmissionNumber(recordData.mctActivityInstanceSid)) || 'error-details.json';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);
            toast.success(Success_Messages.File_download_successfully);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error(Error_Messages.Failed_to_download_error_details);
        }
    };

    const isDisabled = checkAccess('report_detail_page', 'VWNA') || checkAccess('report_detail_page', 'NOAC');

    const uploadedAttachmentsHeaders: any[] = [
        {
            name: 'updatedDate',
            header: (
                <div className='grid-header-custom-style'>
                    Submission Date
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 120,
            // maxWidth: 200,
            render: ({ data }: { data: any }) => {
                return formatDateAndTime(data.updatedDate);
            },
        },
        {
            name: 'fileName',
            header:
                (
                    <div className='grid-header-custom-style'>
                        File Name
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 300,
            // maxWidth: 350,
        },
        {
            name: 'uploadTypeLkpcd',
            header:
                (
                    <div className='grid-header-custom-style'>
                        File Type
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 120,
            // maxWidth: 150,
            render: ({ data }: { data: any }) => {
                if (data?.uploadTypeLkpcd === 'IV') {
                    return matchingUploadedErrorFileTypeLKPCD(data.uploadTypeLkpcd)
                } else {
                    return matchingUploadedFileTypeLKPCD(data.uploadTypeLkpcd)
                }
            },
        },
        // {
        //     name: 'mcoViewableFlag',
        //     header:
        //         (
        //             <div className='grid-header-custom-style'>
        //                 MCO Viewable
        //             </div>
        //         ),
        //     defaultFlex: 1,
        //     resizable: true,
        //     minWidth: 120,
        //     // maxWidth: 200,
        //     render: ({ data }: { data: any }) => {
        //         return getMatchingYesOrNoValues(data.mcoViewableFlag)
        //     },
        // },
        //   {
        //     name: 'mctActivityInstanceSid',
        //     header: (
        //         <div className='grid-header-custom-style'>
        //             Submission #
        //         </div>
        //     ),
        //     defaultFlex: 1,
        //     resizable: true,
        //     minWidth: 90,
        //     maxWidth: 150,
        //     render: ({ data }: { data: any }) => {
        //         return getSubmissionNumber(data.mctActivityInstanceSid);
        //     },

        // },
        {
            name: 'action',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Download/View
                    </div>
                ),
            resizable: true,
            defaultFlex: 1,
            minWidth: 100,
            // maxWidth: 200,
            render: ({ data }: { data: any }) => {

                const isJsonFile = data?.fileName?.endsWith('_error.json');

                return (
                    <div>
                        <a className={isDisabled ? 'disabled-row' : "file-link"}
                            onClick={isDisabled ? (e) => e.preventDefault() : (e) => handleDownload(data, e)}
                            href={isDisabled ? undefined : '#'}
                            target="_blank" rel="noopener noreferrer"
                            style={{ display: 'inline-flex', margin: '5px' }}
                            title="View File">
                            View File <FaExternalLinkAlt style={{ marginLeft: '5px' }} />
                        </a>
                        <span style={{ margin: '5px' }}>or</span>

                        {isJsonFile ? (
                            <a
                                className={isDisabled ? 'disabled-row' : 'file-link'}
                                onClick={isDisabled ? (e) => e.preventDefault() : (e) => handleDownload(data, e)}
                                href={isDisabled ? undefined : '#'}
                                download={isDisabled ? undefined : data?.fileName}
                                style={{ display: 'inline-flex', margin: '5px' }}
                                title="Download File"
                            >
                                Download <FaDownload style={{ marginLeft: '5px' }} />
                            </a>
                        ) : (
                            <a
                                className={isDisabled ? 'disabled-row' : 'file-link'}
                                onClick={isDisabled ? (e) => e.preventDefault() : (e) => handleDownload(data, e)}
                                href={isDisabled ? undefined : '#'}
                                download={isDisabled ? undefined : data?.fileName}
                                style={{ display: 'inline-flex', margin: '5px' }}
                                title="Download File"
                            >
                                Download <FaDownload style={{ marginLeft: '5px' }} />
                            </a>
                        )}
                    </div>
                );
            },
        }
    ]

    const handleRichTextChangeNotes = () => {
    }
    function joinClasses(...classes: (string | undefined)[]): string {
        return classes.filter(Boolean).join(' ')
    }
    const wrapperClasses = joinClasses('usa-fieldset usa-form-group')

    function handleGeneralInputData(event: any) {
        const { name, value } = event.target
        // setUploadNewReport((prevState: any) => ({ ...prevState, [name]: value }))
    }

    const formatDateForInput = (value: any) => {
        if (value) {
            const date = moment.utc(value);
            return date.isValid() ? date.format('MM/DD/YYYY') : '';
            // return formatDateForDisplay(value, 'MM/DD/YYYY');
        }
        return '';
    };

    const formatDateAndTime = (value: any) => {
        if (value) {
            // return formatDateForDisplay(value, 'MM/DD/YYYY h:mm:ss:SSS A');

            const date = moment.utc(value);
            return date.isValid() ? date.format('MM/DD/YYYY h:mm:ss:SSS A') : '';
        }
        return '';
    };

    const viewUploadedDocs = (event: any) => {
        const documentUrl = '/assets/docs/ScreenMockUp-ManagedCareCollabTool.pdf';
        window.open(documentUrl, '_blank');
    }

    const formattedSubmissionDate = recordData?.last_submission_date
        ? formatDateForDisplay(recordData.last_submission_date, 'MM/DD/YYYY hh:mm A')
        : '';
    const [fileValue, setFileValue] = useState<any[]>([]);

    useEffect(() => {
        if (recordData) {
            const uploadedFiles = Array.isArray(recordData.uploadFiles) ? recordData.uploadFiles : [];
            setFileValue(uploadedFiles);
        }
    }, [recordData]);

    const headers = [
        'Date & Time',
        'Activity',
        'Submission#',
        'Activity Status',
        'Updated By',
        // 'MCOs Action',
        // 'Reviewer Decision',
        // 'Previous Due Date',
        // 'New Due Date',
        'MCO state note',
        // 'Internal Note'
    ];

    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [selectedHeaders, setSelectedHeaders] = useState<string[]>(headers);
    const toggleModal = () => {
        setSelectedHeaders(headers);
        setIsExportModalOpen(!isExportModalOpen);
    };

    const handleHeaderChange = (header: string) => {
        setSelectedHeaders((prev) =>
            prev.includes(header) ? prev.filter((h) => h !== header) : [...prev, header]
        );
    };

    const handleSelectAllChange = () => {
        setSelectedHeaders(selectedHeaders.length === headers.length ? [] : headers);
    };

    const handleExportToExcel = () => {
        const dataToExport = reportActivityList.map((item: any) => {

            const row: { [key: string]: any } = {};
            selectedHeaders.forEach((header) => {
                row[header] = {
                    'Date & Time': formatDateAndTime(item?.updatedDate),
                    'Activity': matchingreportActivityLKPCD(item?.activityLkpcd),
                    'Submission #': getSubmissionNumber(item?.mctReportActivitySid),
                    'Activity Status': item?.submitFlag === 'Y' ? 'Completed' : 'Pending',
                    'MCO state note': item?.activityNotes,
                    'Updated By': isNonStateUser ? maskUpdatedBy(item?.updatedBy) : item?.updatedBy,
                }[header]
            });
            return row;
        });

        // Create a worksheet
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const headerRow = selectedHeaders.map((header) => header);
        XLSX.utils.sheet_add_aoa(ws, [headerRow], { origin: 'A1' });

        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'state actions timeline list');
        XLSX.writeFile(wb, 'state_actions_timeline.xlsx');
        setIsExportModalOpen(false);
    };

    const getSubmissionNumber = (activityId: string) => {
        const activity = reportActivityList.find((element: any) => element.mctReportActivitySid === activityId);
        return activity ? activity.submissionNumber : '';
    };

    const maskUpdatedBy = (value: any) => {
        if (!value) return '';
        if (value.includes('@nebraska.gov')) {
            const visiblePart = value.slice(0, 2);
            const maskedPart = '*'.repeat(value.length - 2);
            return `${visiblePart}${maskedPart}`;
        }
        return value;
    };

    const getMCTReportSubActivityByActivityId = async (activityId: any) => {
        try {
            const reviewerGroupResponse = await ReportInventoryService.getMCTReportSubActivityByActivityId(activityId);
            if (reviewerGroupResponse) {
                const reviewerGroupList = reviewerGroupResponse.data;
                setReportSubActivityList(reviewerGroupList);
            }
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        if (activityData?.mctReportActivitySid) {
            // if (activityData?.reviewStatusLkpcd === '30' || activityData?.reviewStatusLkpcd === '35') {
            getMCTReportSubActivityByActivityId(activityData?.mctReportActivitySid);
            // }
        }
    }, [activityData?.mctReportActivitySid]);

    const getMatchingDecisionStatus = (data: any) => {
        const matchedItem = reviewDecisionLKPCDList.find((code: any) => code.lkpdmn_lkpcd === data);
        return matchedItem?.lkdmn_lkpcd_desc || data;
    };

    // Add this helper function in your component
    const getDecisionOrBusinessStatus = (value: any) => {
        // Try decision status first
        const decision = getMatchingDecisionStatus(value);
        if (decision && decision !== value) return decision;

        // If not found, try business status
        const business = matchingMcoActionDecisionLKPCD(value);
        if (business && business !== value) return business;

        // Fallback to raw value
        return value;
    };

    const reviewerActionsHeaders: any[] = [
        {
            name: 'organizationUnitCode',
            header: (
                <div className='grid-header-custom-style'>
                    Reviewer Group
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 140,
            render: ({ value }: { value: any }) => {
                const value1 = getMatchingMcOrgUnit(value);
                return (
                    <div title={value1}>
                        {value1}
                    </div>
                );
            },
        },
        {
            name: 'subActivityStartDatetime',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Start Date Time
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 250,
            render: ({ value }: { value: any }) => (
                <div>{formatDateAndTime(value)}</div>
            ),
        },
        {
            name: 'subActivityCloseDatetime',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Finish Date Time
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 250,
            render: ({ value }: { value: any }) => (
                <div>{formatDateAndTime(value)}</div>
            ),
        },
        {
            name: 'submitFlag',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Activity Status
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 250,
            render: ({ value }: any) => {
                switch (value) {
                    case 'Y':
                        return 'Completed';
                    case 'N':
                        return 'Pending';
                    default:
                        return '';
                }
            }
        },
        {
            name: 'decisionActionLkpcd',
            header: (
                <div className='grid-header-custom-style'>
                    Decision
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 140,
            render: ({ value }: { value: any }) => (
                <div>{getMatchingDecisionStatus(value)}</div>
            ),
        },
        {
            name: 'updatedBy',
            header:
                (
                    <div className='grid-header-custom-style'>
                        Updated By
                    </div>
                ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 250,
            render: ({ data }: any) => {
                return (
                    <span>
                        {isNonStateUser ? maskUpdatedBy(data?.updatedBy) : data?.updatedBy}
                    </span>
                );
            },
        },
    ]

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="Action Details" />
                </div>
            </div>

            <div className="form-layout">
                {isLoading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading.....</p>
                    </div>
                ) :
                    <>
                        <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: '-30px' }}>
                            <Button
                                className="OkButton"
                                onClick={() => handleCancel()}
                            >
                                Cancel
                            </Button>
                        </div>

                        <div className="details-block">
                            <h3><b>Report Instance:</b></h3>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="MCO Name"
                                        name="plan_name"
                                        placeholder="Health Plan"
                                        value={recordData?.plan_name}
                                        onChange={handleGeneralInputData}
                                        disabled={true}

                                    />
                                </div>
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Report Name"
                                        name="report_name"
                                        placeholder="Report Name"
                                        value={recordData?.report_name}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Reference #"
                                        name="start_reference_number"
                                        placeholder="Reference Number"
                                        value={recordData?.start_reference_number}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Reporting Type"
                                        name="reporting_type_lkpcd"
                                        placeholder="Reporting Type"
                                        // value={getTextFromShortCode(recordData?.reporting_type_lkpcd || '')}
                                        value={matchingReportingTypeLkpcd(recordData?.reporting_type_lkpcd)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label=" Allowed Submission Channel"
                                        name="report_sbmsn_mode_lkpcd"
                                        placeholder="Channel"
                                        value={matchingSubmissionModelLkpcd(recordData?.report_sbmsn_mode_lkpcd)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element">
                                    <InputText
                                        label="Latest Due Date"
                                        name="latest_due_date"
                                        value={formatDateForInput(recordData?.latest_due_date)}
                                        onChange={handleGeneralInputData}
                                        placeholder={'MM-DD-YYYY'}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Frequency"
                                        name="frequency"
                                        placeholder="Frequency"
                                        value={matchingFrequencyLkpcd(recordData?.due_date_frequency_lkpcd)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" >
                                    <InputText
                                        label="Period"
                                        name="plan_name"
                                        placeholder="Period"
                                        value={formatDateForInput(recordData?.period_begin_date) + ' - ' + formatDateForInput(recordData?.period_end_date)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="details-block">
                            <h3><b>Activity:</b></h3>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Created Date and Time"
                                        name="createdDate"
                                        placeholder="Created Date and Time"
                                        value={formatDateAndTime(activityData?.createdDate)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Description"
                                        name="activityNotes"
                                        placeholder="Description"
                                        value={matchingreportActivityLKPCD(activityData?.activityLkpcd)}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <InputText
                                        label="Submission #"
                                        name="submissionNumber"
                                        placeholder='0'
                                        value={activityData?.submissionNumber}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                                <div className="element" >
                                    <InputText
                                        context="registration"
                                        label="Review #"
                                        name="reviewNumber"
                                        placeholder="0"
                                        value={activityData?.reviewNumber}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <div className="usa-form-group">
                                        <InputText
                                            context="registration"
                                            label="Submission Status"
                                            name="submsnStatusLkpcd"
                                            placeholder="Submission Status"
                                            value={matchingBusinessStatusLkpcd(activityData?.submsnStatusLkpcd)}
                                            onChange={handleGeneralInputData}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="element" >
                                    <InputText
                                        label="Review Status"
                                        name="reviewStatusLkpcd"
                                        placeholder="Review Status"
                                        value={matchingAfStatusLkpcd(activityData?.reviewStatusLkpcd)}
                                        // value={formattedSubmissionDate}
                                        onChange={handleGeneralInputData}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="row1">
                                <div className="element" >
                                    <div className="usa-form-group">
                                        <InputText
                                            label="Start Date and Time"
                                            name="currentReviewStatus"
                                            placeholder="Start Date and Time"
                                            value={formatDateAndTime(activityData?.activityStartDatetime)}
                                            onChange={handleGeneralInputData}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="element" >
                                    <div className="usa-form-group">
                                        <InputText
                                            context="registration"
                                            label="Finished Date and Time"
                                            name="activityCloseDatetime"
                                            placeholder="Finished Date and Time"
                                            value={formatDateAndTime(activityData?.activityCloseDatetime)}
                                            onChange={handleGeneralInputData}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row1">
                                <div className="element" >
                                    <div className="usa-form-group">
                                        <InputText
                                            label="Activity Due Date"
                                            name="activityDueDate"
                                            placeholder="Activity Due Date"
                                            value={formatDateForInput(activityData?.activityDueDate)}
                                            onChange={handleGeneralInputData}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className="element" >
                                    <div className="usa-form-group">
                                        <InputText
                                            context="registration"
                                            label="Activity Status"
                                            name="submitFlag"
                                            placeholder="Activity Status"
                                            value={
                                                activityData?.submitFlag === 'Y'
                                                    ? 'Completed'
                                                    : activityData?.submitFlag === 'N'
                                                        ? 'Pending'
                                                        : activityData?.submitFlag || ''
                                            }
                                            onChange={handleGeneralInputData}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            {(activityData?.activityLkpcd === '140' || activityData?.activityLkpcd === '150') &&
                                < div className="row1">
                                    <div className="element" >
                                        <div className="usa-form-group">
                                            <InputText
                                                label="Submission Date and Time"
                                                name="submsnDate"
                                                placeholder="Submission Date and Time"
                                                value={formatDateAndTime(activityData?.submsnDate)}
                                                onChange={handleGeneralInputData}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="element" >
                                        <div className="usa-form-group">
                                            <InputText
                                                context="registration"
                                                label="Actual Submission Channel"
                                                name="actualSbmsnModeLkpcd"
                                                placeholder="Actual Submission Channel"
                                                value={matchingSubmissionModelLkpcd(activityData?.actualSbmsnModeLkpcd)}
                                                onChange={handleGeneralInputData}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            {activityData?.submsnStatusLkpcd === '20' &&
                                <div className="row1">
                                    <div className="element" >
                                        <div className="usa-form-group">
                                            <InputText
                                                label="Requested Due Date"
                                                name="requested_due_date"
                                                placeholder="Requested Due Date"
                                                value={activityData?.activityLkpcd === '270' && activityData?.submitFlag === 'N' ?
                                                    formatDateForInput(activityData?.acceptedDueDate) : formatDateForInput(recordData?.requested_due_date)}
                                                onChange={handleGeneralInputData}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="element" >
                                        <div className="usa-form-group">
                                            <InputText
                                                context="registration"
                                                label="Approved Due Date"
                                                name="acceptedDueDate"
                                                placeholder="Approved Due Date"
                                                value={activityData?.activityLkpcd === '300' ? formatDateForInput(activityData?.acceptedDueDate) : ''}
                                                onChange={handleGeneralInputData}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            {(activityData?.activityLkpcd === '140' ||
                                activityData?.activityLkpcd === '150' ||
                                activityData?.activityLkpcd === '180' ||
                                activityData?.activityLkpcd === '190' ||
                                activityData?.activityLkpcd === '240' ||
                                activityData?.activityLkpcd === '250' ||
                                activityData?.activityLkpcd === '260' ||
                                activityData?.activityLkpcd === '270' ||
                                activityData?.activityLkpcd === '280' ||
                                activityData?.activityLkpcd === '301' ||
                                activityData?.activityLkpcd === '308' ||
                                activityData?.activityLkpcd === '310' ||
                                activityData?.activityLkpcd === '320' ||
                                activityData?.activityLkpcd === '341' ||
                                activityData?.activityLkpcd === '350') &&
                                <div className="row1">
                                    <div className="element" >
                                        <div className="usa-form-group">
                                            <InputText
                                                label="Action/Decision"
                                                name="decisionActionLkpcd"
                                                placeholder="Action/Decision"
                                                value={getDecisionOrBusinessStatus(activityData?.decisionActionLkpcd)}
                                                onChange={handleGeneralInputData}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {reportSubActivityList.length > 0 &&
                            <div className="details-block">
                                <div className="usa-form-group" style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                                    <label >
                                        <b>Sub-Activities:</b>
                                    </label>
                                    <div style={{ position: 'relative', zIndex: 10 }}>
                                        <ReactDataGrid
                                            licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                                            idProperty="key"
                                            style={gridStyle}
                                            pagination
                                            columns={reviewerActionsHeaders}
                                            dataSource={reportSubActivityList}
                                            sortable={true}
                                            defaultLimit={5}
                                            rowHeight={50}
                                            enableColumnAutosize={true}
                                            pageSizes={[5, 10, 20, 30, 40, 50]}
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="details-block">
                            <div className="usa-form-group" style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem', position: 'relative', zIndex: 10 }}>
                                <label >
                                    <b>Attachments Uploaded/Submitted:</b>
                                </label>
                                <div style={{ marginTop: 10 }}>
                                    <ReactDataGrid
                                        licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                                        idProperty="key"
                                        style={gridStyle}
                                        pagination
                                        columns={uploadedAttachmentsHeaders}
                                        dataSource={uploadedFileList}
                                        sortable={true}
                                        // onFilterValueChange={handleFilterChangeGrid}
                                        defaultLimit={5}
                                        // defaultFilterValue={filterValue}
                                        rowHeight={50}
                                        loading={isFilesGridLoading}
                                        enableColumnAutosize={true}
                                        pageSizes={[5, 10, 20, 30, 40, 50]}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                            <label style={{ marginBottom: '10px' }}>
                                <b>MCO-State Notes:</b>
                            </label>
                            <ReactQuill
                                style={{ maxHeight: '150px', overflowY: 'auto', width: '100%', borderColor: '#3e3e3f', borderWidth: '1px' }}
                                value={combinedNotes}
                                onChange={handleRichTextChangeNotes}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'], // formatting options
                                        [{ list: 'ordered' }, { list: 'bullet' }], // list options
                                        [{ align: [] }], // alignment options
                                        ['clean'], // remove formatting option
                                    ],
                                }}
                            />

                        </div>

                        {certificationData?.certifyingStatement &&
                            (
                                <div className="details-block" style={{ padding: 20, marginBottom: 20 }}>
                                    <div className="usa-form-group" style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem', position: 'relative' }}>
                                        <label >
                                            <b>Certification Statement:</b>
                                        </label>
                                        <div style={{ marginTop: 10 }}>
                                            <div style={{ fontStyle: 'italic', marginBottom: 10 }}>
                                                This certification must be signed by the MCO Chief Executive Officer, the MCO Chief Financial Officer, or an individual who has been delegated authority to sign for, and who reports to the MCO Chief Executive Officer or MCO Chief Financial Officer.
                                            </div>
                                            <div style={{ marginBottom: 10 }}>
                                                <input
                                                    type="checkbox"
                                                    checked={certificationData?.certifyingStatement
                                                        ? true
                                                        : false}
                                                    // onChange={e => setIsCertified(e.target.checked)}
                                                    style={{ marginRight: 8 }}
                                                />
                                                <span>
                                                    {certificationData?.certifyingStatement
                                                        ? certificationData.certifyingStatement
                                                        : ''
                                                    }
                                                </span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                                <label style={{ width: 60, fontWeight: 600 }}>Name</label>
                                                <input
                                                    type="text"
                                                    value={certificationData?.certifyingPersonName}
                                                    // onChange={e => setCertName(certificationData?.certifyingPersonName)}
                                                    readOnly
                                                    style={{
                                                        width: '250px', // Set a fixed width
                                                        border: '1px solid #000',
                                                        borderRadius: '4px',
                                                        background: '#fff',
                                                        marginLeft: 10,
                                                        fontStyle: 'italic',
                                                        padding: '8px 12px'
                                                    }}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ width: 60, fontWeight: 600 }}>Title</label>
                                                <input
                                                    type="text"
                                                    value={certificationData?.certifyingPersonTitle}
                                                    // onChange={e => setCertTitle(certificationData?.certifyingPersonTitle)}
                                                    readOnly
                                                    style={{
                                                        width: '250px', // Set a fixed width
                                                        border: '1px solid #000',
                                                        borderRadius: '4px',
                                                        background: '#fff',
                                                        marginLeft: 10,
                                                        fontStyle: 'italic',
                                                        padding: '8px 12px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        <Modal
                            isOpen={isExportModalOpen}
                            onRequestClose={toggleModal}
                            shouldCloseOnOverlayClick={false}
                            contentLabel="Export data"
                            style={{
                                content: {
                                    width: '500px',
                                    height: '500px',
                                    margin: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                },
                                overlay: {
                                    zIndex: 1000,
                                },
                            }}
                        >
                            <h2 style={{ marginBottom: '20px' }}><b>Select Fields for Export</b></h2>
                            <div>
                                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="checkbox"
                                        id="selectAll"
                                        checked={selectedHeaders.length === (headers.length)}
                                        onChange={handleSelectAllChange}
                                        style={{ width: '15px', height: '15px', marginRight: '10px' }}
                                    />
                                    <label htmlFor="selectAll" style={{ verticalAlign: 'middle' }}>Select All</label>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                                    {(headers).map((header) => (
                                        <div key={header} style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                id={header}
                                                checked={selectedHeaders.includes(header)}
                                                onChange={() => handleHeaderChange(header)}
                                                style={{ width: '15px', height: '15px', marginRight: '10px' }}
                                            />
                                            <label htmlFor={header} style={{ verticalAlign: 'middle' }}>{header}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="usa-form-group" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', height: '100%' }}>
                                <button
                                    disabled={selectedHeaders.length === 0}
                                    className='usa-button'
                                    onClick={handleExportToExcel}
                                >
                                    Download Excel
                                </button>
                                <button
                                    className='usa-button'
                                    onClick={toggleModal}
                                >
                                    Close
                                </button>
                            </div>
                        </Modal>
                    </>
                }

                <div className="row1">
                    <div className="element" >
                        <p>
                            <b>Last Updated By : </b>
                            {isNonStateUser ? maskUpdatedBy(activityData?.updatedBy) : activityData?.updatedBy}
                        </p>
                    </div>
                    <div className="element" >
                        <p><b>Last Updated Date : </b>{formatDateAndTime(activityData?.updatedDate)}</p>
                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}